import { createContext } from "react";

export type AdsContextType = {
  showAds: boolean;
};

const defaultValue: AdsContextType = {
  showAds: false,
};

export const AdsContext = createContext(defaultValue);
